export enum ApplicationErrors {
  projectID_is_missing = 'ProjectID is missing',
  data_fetch_error = 'Could not get data from server',
}

export interface ApiError extends Error {
  statusCode?: number;
}

export function isFailedToFetchError(error: unknown): error is Error {
  return error instanceof Error && error.message === 'Failed to fetch';
}
